/**
 * Notion-hosted competitor scan form, embedded on desktop so the page converts
 * in place rather than sending people off-site. Mobile uses FORM_PAGE_URL below.
 */
export const FORM_EMBED_URL = 'https://bzwiers.notion.site/ebd//271a4250e076448fb277f7e47551aa53';

/**
 * The same form opened directly, used on mobile.
 *
 * Embedding it crashes mobile browsers: the iframe loads a full Notion app
 * into a tab already running the particle canvas and the fixed noise overlay,
 * and the tab runs out of memory. Deferring the load does not help, since peak
 * memory is identical whenever it happens, so mobile links out instead.
 */
export const FORM_PAGE_URL = 'https://bzwiers.notion.site/271a4250e076448fb277f7e47551aa53?pvs=105';
